import { Box, Container } from '@mui/material'
import { useEffect, useState } from 'react'
import CustomButton from 'Components/CustomButton/CustomButton'
import { makeGetRequest, makePostRequest } from 'utils/api'
import urls from 'utils/urls'
import ListOperations from './ListOperations'
import CreateMessage from 'containers/MyInbox/CreateMessage'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

export const MesProjects = ({
  CreateProjectModal,
  updateTodo = false,
  createProject,
  setProjectTaskId,
  setProjectTaskName,
  // SmartFeed — quand on arrive via la carte « Un projet est en sommeil »
  // (/todos?filter=sleeping), on ne liste QUE les projets sans action depuis
  // 30 jours. Vide = comportement normal (tous les projets).
  projectFilter = '',
}) => {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [mOpen, setMOpen] = useState(false)
  const [operations, setOperations] = useState({})
  const [selectedRows, setSelectedRows] = useState([])
  useEffect(() => {
    fetchOperations()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createProject, projectFilter])

  const fetchOperations = async (pagination = '') => {
    let url = `${urls.projectOperations}`
    // Filtre « en sommeil » porté par le lien de la publication SmartFeed.
    if (projectFilter === 'sleeping') {
      url += url.includes('?') ? '&sleeping=1' : '?sleeping=1'
    }
    // Carte « Des projets sans objectif » (/todos?filter=projects&no_objective=1) :
    // ne liste QUE les projets actifs rattachés à aucun objectif.
    if (projectFilter === 'no_objective') {
      url += url.includes('?') ? '&no_objective=1' : '?no_objective=1'
    }
    if (pagination !== '') {
      url += pagination
    }
    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setOperations({ ...response.data })
    }
  }
  const deleteBulkOperations = async () => {
    if (selectedRows.length === 0) {
      alert(t('mesToDo.selectOperationAlert'))
    } else {
      const filteredOperations = operations.results.filter((v) => selectedRows.indexOf(v.id) === -1)
      setOperations({
        ...operations,
        results: filteredOperations,
        count: operations.count - selectedRows.length,
      })
      const response = await makePostRequest(
        urls.deleteBulkProjectOperations,
        { selected: selectedRows },
        {},
        true,
      )
      if (response.status === 200) {
        updateTodo()
        console.log('Deleted Successfully')
      }
    }
  }
  return (
    <>
      {mOpen && (
        <CreateMessage
          setMOpen={setMOpen}
          title={t('mesToDo.shareProject')}
          settingId={9}
          project={operations.results.filter((v) => v.id === selectedRows[0])[0]}
        />
      )}
      <Container maxWidth="xl">
        <Box justifyContent="flex-end" padding={2} display="flex">
          <Box>
            <CustomButton
              onClick={() => {
                if (selectedRows.length === 1) {
                  setMOpen(true)
                } else {
                  alert(t('mesToDo.selectOneToShareAlert'))
                }
              }}
            >
              {t('mesToDo.share')}
            </CustomButton>
            <CustomButton>{t('mesToDo.hideCompleted')}</CustomButton>
            <CustomButton
              onClick={() => {
                CreateProjectModal()
              }}
            >
              {t('mesToDo.add')}
            </CustomButton>
            <CustomButton onClick={deleteBulkOperations}>{t('mesToDo.delete')}</CustomButton>
          </Box>
        </Box>
        <ListOperations
          fetchOperations={fetchOperations}
          setSelectedRows={setSelectedRows}
          operations={operations}
          setProjectTaskId={setProjectTaskId}
          setProjectTaskName={setProjectTaskName}
        />
      </Container>
    </>
  )
}
